<template>
    <panel title="Users">
      <v-container 
        fluid
        align-content-start
        justify-start>
         <v-layout row>
           <v-flex
              xs-3
              text-xs-left
              class="selectUser"
              align-content-left
              my-0
              py-0
              ml-4
              pl-4
              >
              <div> User Name </div>
            </v-flex>
            <v-flex
            xs3
            text-xs-left
            ml-0
            class="selectUser">
              User Email
              </v-flex> 
            <v-spacer/>
            <v-flex
              text-xs-right
              >
              <v-btn
                v-if="$store.state.user && $store.state.user.role === 'Admin'"
                slot="action"
                :to="{
                  name: 'users-create'
                }"
                :color="strongColor"
                dark
                large
                right
                >
                Create New User
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-if="users && users.length > 0">
            <v-layout 
              mt-0
              row>
             <v-flex 
              xs12 >
              <v-card 
                flat>
                <v-list>
                  <v-list-tile
                    v-for="user in users"
                    :key="user.id" 
                    >
                    <v-layout
                      
                      class="text-xs-left">
                      <v-flex
                        xs3
                        align-content-left
                        pl-0
                        ml-0>
                        <v-btn 
                          :to="{
                            name: 'user-edit',
                            params: {
                              userId: user.id
                            }
                          }"
                          flat
                          >
                          <v-list-tile-action>
                            <div class="body-2 text-xs-left" > {{ user.name }} </div>
                          </v-list-tile-action> 
                        </v-btn>
                      </v-flex>
                      <v-flex 
                      xs3
                      ml-3>
                      <v-list-tile-content>
                         <v-list-tile-title             
                          v-text="user.email"/>
                      </v-list-tile-content>
                      </v-flex>
                      </v-layout>
                    </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
          </div>
          <div v-else>
            No matching results
          </div>
      </v-container>
    </panel>       
</template>
<script>
import UsersService from '@/services/UsersService'
import { STRONG_COLOR } from "@/components/globals/consts";
import {mapState} from 'vuex'
export default {
	data () {
		return {
      users: null,
      strongColor: STRONG_COLOR,
		}
  },
  computed: {
		...mapState([
			 'user'
		])
	},
	watch: {
		'$route.query.search': {
			immediate: true,
			async handler (value) {
      let tempUsers =  (await UsersService.index(value)).data
      this.users = await tempUsers.sort(this.orderByName)

			}
		}
  },
  methods: {
      orderByName(a, b) {
      if (a.name.toUpperCase() && b.name.toUpperCase()) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        } else if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        }
        return 0
      }
    }
  }

}
</script>
<style scoped>
.selectUser {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UsersPanel.vue